import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=138e5842&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=138e5842&prod&scoped=true&lang=css"
import style1 from "./Attachments.vue?vue&type=style&index=1&id=138e5842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e5842",
  null
  
)

export default component.exports